<template>
  <div
    class="flex items-center mb-3 md:mb-0 w-full flex-wrap col-span-6 sm:col-span-12"
  >
    <ArticleHeadPerson
      v-if="article.relQAQpersons && article.relQAQpersons[0]"
      :person="article.relQAQpersons[0].person"
      :class="questionHasAnswer ? 'order-3' : 'order-1'"
      type="person"
    />
    <div
      v-else
      class="headline-s"
      :class="questionHasAnswer ? 'order-3' : 'order-1'"
    >
      <span class="article-head-m whitespace-pre opacity-35 !font-medium">{{
        article?.typeId === 4 ? $t('qaRaadhus') : $t('qaUdvalget')
      }}</span>
    </div>
    <span class="headline-s order-2">
      <span class="font-light opacity-35 whitespace-pre">{{
        ` ${qaLabel} `
      }}</span>
    </span>
    <ArticleHeadPerson
      v-if="article.aperson"
      :person="article.aperson"
      :class="questionHasAnswer ? 'order-1' : 'order-3'"
      type="person"
    />
    <div
      v-else
      class="headline-s"
      :class="questionHasAnswer ? 'order-1' : 'order-3'"
    >
      <span class="article-head-m whitespace-pre opacity-35 !font-medium">{{
        article?.typeId === 4 ? $t('qaRaadhus') : $t('qaUdvalget')
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { QADto } from '~/typesAuto/apicore/v1'

const nuxtApp = useNuxtApp()

const props = defineProps<{ article: QADto }>()

const qaLabel = computed(() => {
  if (questionHasAnswer.value) {
    return nuxtApp.$t('Answers')
  } else {
    return nuxtApp.$t('Asks')
  }
})

const questionHasAnswer = computed(() => {
  return Boolean(props.article.atext)
})
</script>
